import React from 'react';
import { Box, Typography, alpha } from '@mui/material';

interface CircularScoreProps {
  value: number;
  color: string;
  size?: number;
}

const CircularScore: React.FC<CircularScoreProps> = ({ value, color, size = 64 }) => {
  const radius = (size - 8) / 2;
  const circumference = 2 * Math.PI * radius;
  const progress = Math.min(value, 100);
  const offset = circumference - (progress / 100) * circumference;
  return (
    <Box sx={{ position: 'relative', width: size, height: size, flexShrink: 0 }}>
      <svg width={size} height={size} style={{ transform: 'rotate(-90deg)' }}>
        <circle cx={size / 2} cy={size / 2} r={radius} fill="none" stroke={alpha(color, 0.15)} strokeWidth={5} />
        <circle cx={size / 2} cy={size / 2} r={radius} fill="none" stroke={color} strokeWidth={5}
          strokeDasharray={circumference} strokeDashoffset={offset} strokeLinecap="round"
          style={{ transition: 'stroke-dashoffset 0.6s ease' }} />
      </svg>
      <Box sx={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Typography variant="body2" fontWeight={700} sx={{ color, fontSize: size > 60 ? '0.85rem' : '0.7rem' }}>
          {value}
        </Typography>
      </Box>
    </Box>
  );
};

export default CircularScore;
